import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const dialogContentVariantList = {
  align: {
    center: 'top-1/2 -translate-y-1/2 data-[state=closed]:slide-out-to-top-1/2 data-[state=open]:slide-in-from-top-1/2',
    top: 'top-0 sm:top-5 sm:data-[state=closed]:slide-out-to-top-5 sm:data-[state=open]:slide-in-from-top-5',
  },
}
export const dialogContentVariants = cva(
  [
    'fixed',
    'left-1/2',
    'z-50',
    'grid',
    'w-full',
    'max-w-lg',
    '-translate-x-1/2',
    'gap-4',
    'border',
    'border-neutral-200',
    'bg-white',
    'p-6',
    'shadow-lg',
    'duration-200',
    'data-[state=open]:animate-in',
    'data-[state=closed]:animate-out',
    'data-[state=closed]:fade-out-0',
    'data-[state=open]:fade-in-0',
    'data-[state=closed]:zoom-out-95',
    'data-[state=open]:zoom-in-95',
    'data-[state=closed]:slide-out-to-left-1/2',
    'data-[state=open]:slide-in-from-left-1/2',
    'dark:border-neutral-800',
    'dark:bg-neutral-950',
    'sm:rounded-xl',
  ],
  {
    variants: dialogContentVariantList,
    defaultVariants: {
      align: 'center',
    },
  },
)
export type DialogContentVariants = VariantProps<typeof dialogContentVariants>

export const dialogTitleVariantList = {
  size: {
    sm: 'text-xs/tight',
    md: 'text-sm/tight',
    lg: 'text-base/tight',
  },
}
export const dialogTitleVariants = cva(
  'mx-6 font-semibold leading-tight',
  {
    variants: dialogTitleVariantList,
  },
)
export type DialogTitleVariants = VariantProps<typeof dialogTitleVariants>
